<div class="container-fluid widget-wrapper">
  <div class="row widget-header" #widgetHeader [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>SDK Details</span><span class="app-title">&nbsp;{{ appName | appPrefix:"for" }}</span>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12 px-0 pr-4">
      <app-sdk-details-apps [sdkDetails]="data?.sdkDetails">
      </app-sdk-details-apps>
    </div>
  </div>
</div>